// Default menu settings configurations

import { MENU_SETTINGS_CONFIG } from "./menu-settings.service";

export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  isExternalLink?: boolean;
  issupportExternalLink?: boolean;
  badge: { type: string, value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
  module?: string;
  pageType?: string;
  image?: string;
}

export interface MenuConfig {
  horizontal_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_menu: {
    items: Partial<MenuItem>[]
  };
}

export const MenuSettingsConfig: MenuConfig = {
  horizontal_menu: {
    items: [
      {
        title: 'Changelog',
        icon: 'la-file',
        page: '/changelog',
        badge: { type: 'badge-danger', value: '3.0' }
      },
      {
        title: 'Templates',
        icon: 'la-television',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Horizontal',
              page: 'null'
            },
            {
              title: 'Vertical',
              page: 'null'
            },
          ]
        }
      },
      {
        title: 'Raise Support',
        icon: 'la-support',
        page: 'https://pixinvent.ticksy.com/',
        isExternalLink: true
      },
      {
        title: 'Documentaion',
        icon: 'la-text-height',
        page: 'https://modern-admin-docs.web.app/html/ltr/documentation/index.html',
        isExternalLink: true,
      }
    ]
  },
  vertical_menu: {
    items: [
      {
        title: 'Home',
        icon: 'la-home',
        page: '/home',
        module: 'orderProcessingManagement',
        pageType: 'view',
      },
      {
        title: 'Dashboard',
        icon: 'la la-file',
        page: '/dashboard',
        module: 'dashboardManagement',
        pageType: 'view'
      },
      {
        title: 'Retail Counter',
        icon: 'la-shopping-bag',
        page: '/reatail-counter',
        module: 'retailCounterManagement',
        pageType: 'view',
      },
      {
        title: 'Stock Managment',
        icon: 'la-luggage-cart',
        page: 'null',
        module: 'stockManagement',
        // image:'assets/images/project-images/stock_management.png',
        submenu: {
          items: [
            {
              title: 'Add Stock',
              icon: 'la-file',
              page: '/add-stock',
              module: 'stockManagement',
              pageType: 'add'
            },
            {
              title: 'Stock Movements',
              page: '/stock-library',
              module: 'stockManagement',
              pageType: 'view'
            },
          ]
        }
      },

      {
        title: 'Product Library',
        icon: 'la-box',
        page: 'null',
        module: 'productLibrary',
        // image:'assets/images/project-images/product_library.png',
        submenu: {
          items: [
            // {
            //   title: 'Add stock',
            //   page: '/order-stock'
            // },
            {
              title: 'Product Library',
              page: '/product-library',
              module: 'productLibrary',
              pageType: 'view'
            },
            {
              title: 'Rental Library',
              page: '/rental-product-library',
              module: 'productLibrary',
              pageType: 'view'
            },
            {
              title: 'Inhouse Products',
              page: '/rakeemart-product-library',
              module: 'inhouseProductLibrary',
              pageType: 'view'
            },
          ]
        }
      },

      {
        title: 'Retailer Management',
        icon: 'la-user-tie',
        page: 'null',
        module: 'retailerOrderManagement',
        // image:'assets/images/project-images/retailer_management.png',
        submenu: {
          items: [
            {
              title: 'Add Retailer Order',
              page: '/place-retailer-order',
              module: 'retailerOrderManagement',
              pageType: 'add'

            },
            {
              title: 'Retailer Order',
              // icon: 'la-file',
              page: '/retailer-orders',
              module: 'retailerOrderManagement',
              pageType: 'view'

            },
            {
              title: 'Supplier Deliveries',
              page: '/supplier-deliveries',
              module: 'retailerOrderManagement',
              pageType: 'view'
            },
          ]
        }
      },
      {
        title: 'User Orders Management',
        icon: 'la-user-circle',
        page: 'null',
        module: 'userOrderManagement',
        // image:'assets/images/project-images/order.png',
        submenu: {
          items: [
            {
              title: 'Online Orders',
              icon: 'la-file',
              page: '/user-orders',
              module: 'userOrderManagement',
              pageType: 'view'
            },
            {
              title: 'Counter Orders',
              icon: 'la-file',
              page: '/user-counter-orders',
              module: 'userCounterManagement',
              pageType: 'view'
            },
          ]
        }
      },
      {
        title: 'Delivery Agent',
        icon: 'la-taxi',
        page: 'null',
        module: 'deliveryManagement',
        submenu: {
          items: [
            {
              title: 'Delivery Agent List',
              page: '/delivery-agent/all',
              module: 'deliveryManagement',
              pageType: 'view'
            },
            {
              title: 'Add Delivery Agent',
              page: '/delivery-agent/create',
              module: 'deliveryManagement',
              pageType: 'add'
            },
          ]
        }
      },
      {
        title: 'Service Provider',
        icon: 'fa fa-briefcase',
        page: 'null',
        module: 'serviceProviderManagement',
        submenu: {
          items: [
            {
              title: 'Service Provider List',
              page: '/service-provider/all',
              module: 'serviceProviderManagement',
              pageType: 'view'
            },
            {
              title: 'Add Service Provider',
              page: '/service-provider/create',
              module: 'serviceProviderManagement',
              pageType: 'add'
            },
            {
              title: 'Service Bookings',
              page: '/service-booking/all',
              module: 'serviceProviderManagement',
              pageType: 'view'
            },
          ]
        }
      },
      // {
      //   title: 'Product library',
      //   icon: 'la-file',
      //   page: '/home',
      //   // badge: { type: 'badge-danger', value: '3.0' }
      // },

      {
        title: 'FAQ\'s',
        icon: 'la-question-circle',
        page: '/faq',
        // image:'assets/images/project-images/faq.png',
        // badge: { type: 'badge-danger', value: '3.0' }
      },
    ]
  }

};






